export default "__VITE_ASSET__BTILgBy6__"